<template>
  <BaseDialog
    :model-value="modelValue"
    :title="'Cadastrar Produto'"
    :icon="'mdi-package-variant'"
    :loading="loading"
    @update:model-value="updateDialog"
    @salvar="salvarProduto"
  >
    <v-form ref="form" v-model="valid" lazy-validation>
      <v-text-field
        v-model="produto.nome"
        label="Nome do Produto"
        :rules="[rules.required]"
        required
        prepend-inner-icon="mdi-tag"
        class="mb-3"
      />
      <v-text-field
        v-model="produto.descricao"
        label="Descrição"
        :rules="[rules.required]"
        required
        prepend-inner-icon="mdi-text"
      />
    </v-form>
  </BaseDialog>
</template>

<script>
import { mapActions } from "vuex";
import api from "../services/api";
import rulesMixin from "@/mixins/rulesMixin";
import BaseDialog from "./comum/BaseDialog.vue";

export default {
  mixins: [rulesMixin],
  components: {
    BaseDialog
  },
  props: {
    modelValue: {
      type: Boolean,
      required: true,
    },
  },
  data: () => ({
    valid: false,
    loading: false,
    produto: {
      nome: "",
      descricao: "",
    },
  }),
  watch: {
    modelValue(val) {
      if (!val) {
        // Limpa o form ao fechar
        this.produto = { nome: "", descricao: "" };
        this.valid = false;
        if (this.$refs.form) this.$refs.form.resetValidation();
      }
    },
  },
  methods: {
    ...mapActions(["triggerFeedback"]),
    updateDialog(val) {
      this.$emit("update:modelValue", val);
    },
    fecharDialog() {
      this.$emit("update:modelValue", false);
    },
    async salvarProduto() {
      const { valid } = await this.$refs.form.validate();
      if (!valid) return;
      this.loading = true;
      try {
        await api.post("/produtos/", this.produto);
        this.triggerFeedback({
          message: "Produto cadastrado com sucesso!",
          color: "success",
          icon: "mdi-check-circle",
        });
        this.fecharDialog();
        this.$emit("produto-cadastrado");
      } catch (error) {
        this.triggerFeedback({
          message: "Erro ao cadastrar produto!",
          color: "error",
          icon: "mdi-alert-circle",
        });
        console.error(error);
      }
      this.loading = false;
    },
  },
};
</script>

<style scoped>
.custom-dialog-card {
  border-radius: 18px;
  border: 1.5px solid #e3e7ed;
  background: #fff;
  box-shadow: 0 2px 12px 0 rgba(60, 60, 60, 0.06);
  transition: box-shadow 0.2s, border-color 0.2s;
}
.custom-dialog-card:hover {
  box-shadow: 0 8px 32px 0 rgba(60, 60, 60, 0.13);
  border-color: #1976d2;
  background: linear-gradient(90deg, #f5fafd 0%, #f0f4ff 100%);
}
.v-card-title {
  font-size: 1.18rem;
  font-weight: 600;
  color: #222;
}
.v-card-text {
  color: #555;
  font-size: 1rem;
}
</style>
